import React, { ImgHTMLAttributes, ReactElement } from 'react'

import * as Styled from './styles'
import { ObjectFit } from './types/ObjectFit'

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  objectFit?: ObjectFit
}

export const Image = ({ className, objectFit = 'cover', ...imgProps }: ImageProps): ReactElement => {
  return (
    <Styled.ImageWrapper className={className}>
      <Styled.Image loading="lazy" objectFit={objectFit} {...imgProps} />
    </Styled.ImageWrapper>
  )
}
